import { render, staticRenderFns } from "./CertificatCard.vue?vue&type=template&id=276944b8"
import script from "./CertificatCard.vue?vue&type=script&lang=js"
export * from "./CertificatCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports